import { mapDispatchToProps, mapStateToProps } from './SetupPhone.container';

import { Box } from '@mui/material';
import { FormikPhoneNumber } from '/b2b/common/components/FormControls/PhoneNumber';
import FormikValidationForm from '/b2b/common/components/organisms/FormikValidationForm';
import PropTypes from 'prop-types';
import React from 'react';
import ReselectMFA from '../components/ReselectMFA';
import { connect } from 'react-redux';
import { setupPhoneSchema } from './SetupPhone.schema';

// eslint-disable-next-line no-use-before-define
export default connect(mapStateToProps, mapDispatchToProps)(SetupPhone);

export function SetupPhone(props) {
    const { phone, onSubmit } = props;
    return (
        <Box
            display="flex"
            flexDirection="column"
            height="100%"
            alignItems="stretch"
            justifyContent="center"
            sx={{ mx: 'auto', px: 2, maxWidth: 700, width: '100%' }}
        >
            <FormikValidationForm
                enableReinitialize
                validateOnMount
                initialValues={{ phone }}
                validationSchema={setupPhoneSchema}
                onSubmit={onSubmit}
                title="auth.amplify.phone.setup.title"
                subtitle="auth.amplify.phone.setup.description"
                submitText="auth.amplify.phone.setup.submitText"
            >
                <Box
                    display="flex"
                    flexDirection="column"
                    width="100%"
                    flexGrow={1}
                    gap={0.5}
                    alignItems="center"
                    mt={4}
                    mb={1}
                    sx={theme => (theme.breakpoints.down('lg') ? { justifyContent: 'center' } : {})}
                >
                    <FormikPhoneNumber
                        name="phone"
                        label="common.fields.phone.label"
                        autoComplete="off"
                        fullWidth
                        required
                        mb={1}
                    />
                </Box>
            </FormikValidationForm>
            <ReselectMFA mfaType="auth.amplify.mfa.sms.title" />
        </Box>
    );
}

SetupPhone.propTypes = {
    phone: PropTypes.string,
    onSubmit: PropTypes.func.isRequired,
};
